import {FilterItemDto} from "./misc";

export const platformsList: FilterItemDto[] = [
    { id: 1, name: 'TikTok', value: 'tiktok', icon: {name: 'tiktok', type: 'fab'} },
    { id: 2, name: 'Instagram', value: 'instagram', icon: {name: 'instagram', type: 'fab'} },
    { id: 3, name: 'YouTube', value: 'youtube', icon: {name: 'youtube', type: 'fab'} },
    { id: 4, name: 'SnapChat', value: 'snapchat', icon: {name: 'snapchat', type: 'fab'} },
];

export interface SocialNotificationsStatus {
    tiktok: boolean;
    instagram: boolean;
    youtube: boolean;
    snapchat: boolean;
}
